<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pi_inoutno,pi_seller,pi_inseller"
      placeholder="输入单据编号、业务员进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/sale/move_out_seller/' + item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.pi_inoutno}}</p>
          <p class="list-item-muted">{{item.pi_vendname}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'" v-if="!isFieldHidden('main.pi_costtotal')">{{item.pi_costtotal}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.pi_status!='已审核'}"
          >{{item.pi_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'" v-if="!isFieldHidden('main.pi_costtotal')">{{getTotal('pi_costtotal')}}</em>
    </div>
    <add-button to="/sale/move_out_seller_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import listCustomization from "@/mixins/listCustomization.js";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list,listCustomization],
  data() {
    return {
      params: {
        caller: 'MoveOutSeller',
        name: 'sale-moveoutseller-querypanel-MAIN', 
      },
      listUrl: "/api/storage/prodinout/list",
      filters: [
        {
          type: "date",
          name: "pi_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              condition: "pi_class = 'MOVEOUTSELLER'",
              mode: "MAIN"
            },
            {
              value: 1,
              label: "待审核",
              condition: "pi_class = 'MOVEOUTSELLER' and pi_status<>'已审核'",
              mode: "MAIN"
            },
            {
              value: 2,
              label: "已审核",
              condition: "pi_class = 'MOVEOUTSELLER' and pi_status='已审核'",
              mode: "MAIN"
            }
          ]
        }
      ]
    };
  }
};
</script>